/* eslint-disable no-useless-escape */
export const REGEX = {
  password: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&* ,.;:'"/()\[\]{}_+\-=])[\w!@#$%^&* ,.;:'"/()\[\]{}_+\-=]{8,20}$/,
};

//        'At least one uppercase, one lowercase, one number & one special character allowed'
//        .max(20, 'Maximum 20 characters allowed')
